<script>
import { SELECT_ALL_EVENT, SELECT_ALL_CHANGE_EVENT, SelectAllBus }  from '@/components/list/TogglerAll.vue'

export default {
    
    data: () => {
        return {
            selectableItems: [],
            selectedItems: []
        }
    },

    computed: {

        itemSelected: function() {
            return ( this.selectedItems.length > 0 )
        },

        isAllSelected: function() {
            return ( 
                this.selectedItems.length > 0 &&
                this.selectedItems.length === this.selectableItems.length
            )
        }
    },

    methods: {

        selectAll() {
            if ( !this.isAllSelected ) {
                this.selectedItems = this.selectableItems
            }
        },

        unselectAll() {
            this.selectedItems = []
        }
    },

    created() {
        SelectAllBus.$on(SELECT_ALL_CHANGE_EVENT, isAllSelected => {
            ( isAllSelected ) ? this.selectAll() : this.unselectAll()
        })
    },

    watch: {

        isFiltering: function() {
            this.unselectAll()
            SelectAllBus.$emit(SELECT_ALL_EVENT, false)
        },

        items: function() {
            SelectAllBus.$emit(SELECT_ALL_EVENT, false)
        },

        selectedItems: function() {
            SelectAllBus.$emit(SELECT_ALL_EVENT, this.isAllSelected)
        }
    }
}

</script>
 